export default __webpack_public_path__ + "static/media/Neddie.9f86f6af.jpg";